import styled from "styled-components";
import { devices } from "../../ExternFormEnrollment.styles";

export const MainContentWrapper = styled.div`
`;

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 25px;
  margin-top: 12px;
`;

export const SelfEmployeedContainer = styled.div`
  margin-bottom: 0px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Headline = styled.p`
  margin-bottom: 12px;
`;

export const HeadlineSelfemployeed = styled.p`
  margin-bottom: 4px;
`;

export const RecieptContainer = styled.div`
  margin-top: 40px;
  width: 97%;
  margin-left: auto;
  margin-right: auto;
`;

export const SalaryInsuranceInfo = styled.p`
    margin-bottom: 24px;
    margin-top: 8px;
    font-size: var(--font-size-small);
    padding-left: 28px;
    padding-right: 28px;
`;
